var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25776 3.78995C4.93216 1.97305 7.33279 0.833496 10.0002 0.833496C15.0628 0.833496 19.1668 4.93755 19.1668 10.0002C19.1668 15.0628 15.0628 19.1668 10.0002 19.1668C4.93755 19.1668 0.833496 15.0628 0.833496 10.0002C0.833496 9.53992 1.20659 9.16683 1.66683 9.16683C2.12707 9.16683 2.50016 9.53992 2.50016 10.0002C2.50016 14.1423 5.85802 17.5002 10.0002 17.5002C14.1423 17.5002 17.5002 14.1423 17.5002 10.0002C17.5002 5.85802 14.1423 2.50016 10.0002 2.50016C7.77962 2.50016 5.78376 3.4649 4.40976 5.00016H5.45475C5.91498 5.00016 6.28808 5.37326 6.28808 5.8335C6.28808 6.29373 5.91498 6.66683 5.45475 6.66683H2.42443C1.96419 6.66683 1.5911 6.29373 1.5911 5.8335V2.8032C1.5911 2.34296 1.96419 1.96987 2.42443 1.96987C2.88467 1.96987 3.25776 2.34296 3.25776 2.8032V3.78995ZM10.0023 4.16683C10.4626 4.16687 10.8356 4.54001 10.8356 5.00025L10.8351 9.65869L14.1241 12.9477C14.4495 13.2731 14.4495 13.8007 14.1241 14.1262C13.7986 14.4516 13.271 14.4516 12.9456 14.1262L9.41249 10.5931C9.25619 10.4368 9.16839 10.2248 9.16841 10.0037L9.16891 5.00008C9.16896 4.53984 9.54209 4.16678 10.0023 4.16683Z",
    fill: "url(#paint0_linear_1778_17632)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1778_17632",
    x1: -0.35817,
    y1: 10.0002,
    x2: 18.0147,
    y2: 19.5971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.20e1fc3470f4e9dfad0bd81cf1744314.svg";
export { ForwardRef as ReactComponent };